<template>
  <div>
    <br />
    <div class="row">
      <div class="col-xl-3 col-12 my-3">
        <label for=""> Référence <span class="text-danger">*</span></label>
        <input
          type="text"
          v-model="seller.reference"
          class="form-control"
          required
        />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for=""> Nom Complet <span class="text-danger">*</span></label>
        <input
          type="text"
          v-model="seller.fullName"
          class="form-control"
          required
        />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for=""> Prénom </label>
        <input type="text" v-model="seller.firstName" class="form-control" />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for=""> Nom </label>
        <input type="text" v-model="seller.lastName" class="form-control" />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Téléphone</label>
        <input type="text" v-model="seller.phone" class="form-control" />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">E-mail</label>
        <input type="email" v-model="seller.email" class="form-control" />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Référence Employé</label>
        <input
          type="text"
          v-model="seller.employee_reference"
          class="form-control"
        />
      </div>
    </div>

    <div class="row mt-3 justify-content-between">
      <div class="col-auto"></div>
      <div class="col-auto">
        <button class="btn btn-success" @click="save(seller)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      seller: {},
    };
  },
  methods: {
    async save(data) {
      await this.$store.dispatch("seller/store", data);
    },
  },
};
</script>
